import type { CallHistoryItem, TalkedBeforeUser } from "../types";

/**
 * 通話履歴を「前に話した女の子」の表示用リストへ畳み込む。
 *
 * BE は 1 通話 = 1 ドキュメントを start_time 降順で返すため、同じ相手が何度も現れる。
 * video / voice を別リクエストで取るぶん結合後の順序は崩れるので、ここで
 * start_time 降順に並べ直してから partner_id で先勝ち（＝直近の通話）に畳む。
 */
export const toTalkedBeforeUsers = (
  items: CallHistoryItem[],
  limit: number,
): TalkedBeforeUser[] => {
  // "yyyyMMddHHmmss" 固定長のため辞書順比較で時刻順になる
  const sorted = [...items].sort((a, b) =>
    b.start_time.localeCompare(a.start_time),
  );

  const seen = new Set<string>();
  const users: TalkedBeforeUser[] = [];

  for (const item of sorted) {
    const partnerId = item.user?.user_id;
    if (!partnerId || seen.has(partnerId)) continue;
    seen.add(partnerId);
    users.push({ ...item.user, last_talked_at: item.start_time });
    if (users.length >= limit) break;
  }

  return users;
};
